/**
 * theme-translations.js
 *
 * External JS version of snippets/theme-translations.liquid.
 * Locale is read from window.__themeConfig.locale (set inline in theme.liquid).
 * Promo badge strings are read from window.__themeConfig.promoBadges.XX
 * (where XX = es | en | de | fr | it | pt).
 *
 * Exposes:
 *   window.themeTranslations  — { locale, strings }
 *   window.t(key)             — dot-path accessor
 *   translateProductCards()   — translates .js-sale-badge / .js-starting-at
 * Also installs a MutationObserver for dynamically added product cards.
 */
(function() {
  const currentLocale = (window.__themeConfig && window.__themeConfig.locale) || 'es';
  const contactConfig = (window.__themeConfig && window.__themeConfig.contact) || {};
  const contactMode = contactConfig.mode || 'whatsapp';
  const chatPageUrl = contactConfig.chatPageUrl || '/pages/consulta-sobre-pedidos';
  const whatsappPhone = String(contactConfig.whatsappPhone || '34616083226').replace(/\D+/g, '');

  function buildChatPageUrl(message) {
    const separator = chatPageUrl.includes('?') ? '&' : '?';
    return `${chatPageUrl}${separator}Message=${encodeURIComponent(message)}`;
  }

  function buildWhatsAppUrl(message) {
    return `https://api.whatsapp.com/send?phone=${whatsappPhone}&text=${encodeURIComponent(message)}`;
  }

  function buildContactUrl(message) {
    return contactMode === 'wazion' ? buildChatPageUrl(message) : buildWhatsAppUrl(message);
  }

  // Todas las traducciones hardcodeadas por idioma
  const translations = {
    es: {
      copy: 'Copiar',
      copied: 'Copiado',
      close: 'Cerrar',
      retry: 'Reintentar',
      searching: 'Buscando…',
      understood: 'Entendido',
      notNow: 'Ahora no',
      shippingRateEstimator: {
        title: 'Calcular el coste real de envío',
        hint: 'Depende del país, el código postal y los productos del carrito.',
        country: 'País',
        postcode: 'Código postal',
        province: 'Provincia/estado (si aplica)',
        button: 'CALCULAR ENVÍO',
        loading: 'Calculando con las tarifas actuales…',
        result: 'Opciones disponibles',
        none: 'No hay una tarifa disponible para esa dirección.',
        error: 'No se pudo calcular ahora. Revise el código postal o inténtelo de nuevo.'
      },
      faqTitle: 'Preguntas Frecuentes',
      productAi: {
        title: '¿Tienes alguna duda sobre este producto?',
        subtitle: 'Nuestro asistente inteligente te responde al momento con información real del producto.',
        placeholder: 'Pregunta...',
        button: 'Preguntar',
        errorResponse: 'No se pudo obtener respuesta. Intenta de nuevo.',
        errorConnection: 'Error de conexión. Verifica tu red.',
        loading: [
          'Analizando tu pregunta…',
          'Consultando catálogos BMW…',
          'Acelerando respuesta…',
          'Verificando compatibilidad…',
          'Procesando información…'
        ]
      },
      orderSteps: [
        { title: 'Pedido recibido', desc: 'Tu compra ha sido registrada correctamente y hemos validado los datos del pedido.' },
        { title: 'Solicitud en curso', desc: 'Hemos solicitado el material necesario a nuestros almacenes, BMW Alemania, proveedores o talleres asociados.' },
        { title: 'En tránsito a nuestras instalaciones', desc: 'El material está de camino a nuestras instalaciones (de logística) para su preparación.' },
        { title: 'Preparando tu envío', desc: 'Hemos recibido el material, estamos comprobado las referencias y preparando el pedido para su expedición.' },
        { title: 'Entregado al transportista', desc: 'Tu pedido ya ha salido de nuestras instalaciones y ha sido entregado al transportista para su envío.' },
        { title: 'En tránsito', desc: 'El pedido está en camino hacia tu dirección. Puedes seguir su recorrido con el número de seguimiento proporcionado.' },
        { title: 'Entregado', desc: '¡Tu pedido ha sido entregado con éxito! Si tienes algún problema con el mismo no dudes en contactarnos.' }
      ],
      calmMessages: {
        created: [
          'Estamos preparando tu pedido. Sin novedades = buena señal',
          'Pedido validado y en cola de preparación. Todo en orden.',
          'Seguimos el plan previsto. Te avisaremos en cuanto avance.'
        ],
        created_stale: [
          'Pedidos complejos toman más tiempo. Todo bajo control.',
          'Estamos gestionando la solicitud. Paciencia y confianza.',
          'El sistema se actualiza regularmente. Te avisamos ante cualquier novedad.'
        ],
        to_courier: [
          'Ya casi está listo para salir. El transportista pasará pronto.',
          'Coordinando recogida con el transportista. En las próximas horas.',
          'Material listo. Solo falta que el transportista pase por nuestras instalaciones.'
        ],
        shipped: [
          'Tu pedido está en ruta. Consulta el estado en la web del transportista.',
          'En camino a tu domicilio. El tiempo de entrega depende ahora del transportista.',
          'Sigue el seguimiento. Si pasan días sin cambios, ponte en contacto con nosotros.'
        ],
        delivered: [
          '¡Tu pedido llegó! ¿Todo correcto? Estamos aquí si necesitas ayuda.',
          'Pedido entregado. Si lo firmaste tú o alguien en tu domicilio, todo está en orden.',
          'Muchas gracias por tu compra. Cualquier duda, contáctanos.'
        ]
      },
      shippingStatus: {
        outForDelivery: 'En reparto',
        deliveryAttempt: 'Intento de entrega',
        pickedUp: 'Recogido',
        delayed: 'Retrasado',
        redirected: 'Redirigido',
        pickupOffice: 'Disponible en oficina',
        undeliverable: 'No entregable',
        damaged: 'Dañado',
        lost: 'Perdido',
        returned: 'Devuelto',
        rejected: 'Rechazado',
        addressError: 'Error de dirección',
        returnProblem: 'Problema con devolución',
        partiallyShipped: 'Parcialmente enviado',
        partiallyDelivered: 'Parcialmente entregado',
        outForPickup: 'Listo para recogida',
        toCourier: 'Entregando al transportista',
        created: 'Creado',
        information: 'Información',
        pending: 'Pendiente',
        na: 'N/A',
        shipped: 'Enviado',
        delivered: 'Entregado'
      },
      order: {
        deliveryInfoLink: '¿Pero cuándo se me entregará mi pedido?',
        materialInfoLink: '¿Si ya tenéis el material por qué todavía no ha sido entregado al transportista?',
        carrierInfoLink: '¿Por qué en la web del transportista pone "no recogido"?',
        notReceivedButton: 'No lo he recibido',
        carrierMoreInfo: 'Más información en la web del transportista:',
        businessDaysNote: '* Días laborables',
        returnPackageButton: 'Devolver el paquete',
        cancelOrderButton: 'Cancelar pedido'
      },
      whatsapp: {
        shipmentWithTracking: 'del envío {tracking}',
        shipmentNoTracking: 'del envío (sin nº de seguimiento)',
        giftCardRequest: 'Quería solicitar la tarjeta de 3€'
      },
      ui: {
        progressBarLabel: 'Progreso estimado del pedido',
        loading: 'Buscando…',
        errorMessage: 'Ha ocurrido un error al consultar el seguimiento.',
        speakToAgent: 'Hablar con un agente',
        retry: 'Reintentar',
        state: 'Estado:',
        businessDaysElapsed: 'Días transcurridos (laborables)',
        tracking: 'Tracking',
        carrier: 'Transportista',
        status: 'Estado',
        lastUpdate: 'Última actualización',
        recipient: 'Destinatario',
        packages: 'Paquetes',
        copyTrackingLabel: 'Copiar número de tracking',
        compensationButton: 'Te regalamos 3 € por la espera',
        helpbarMessage: 'Si tienes cualquier pregunta, puedes hablar con un agente <a href="/pages/consulta-sobre-pedidos?Message=Necesito%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20env%C3%ADo" target="_blank" rel="noopener">pulsando aquí</a>.',
        bizDaysValue: '≈ {count} días laborables',
        bizDaysDisclaimer: 'El número de días laborables indicado es aproximado y podría ser menor: no se contemplan festivos locales, autonómicos o nacionales.'
      },
      legend: {
        completed: 'Completado',
        inProgress: 'En curso',
        pending: 'Pendiente'
      },
      modals: {
        delivery: {
          title: 'Plazos de entrega estimados',
          intro: 'El tiempo de entrega estimado para los pedidos es:',
          spainStock: '<strong>Si el producto está en stock en España:</strong> entre <strong>2 y 7 días laborables</strong>.',
          germanyStock: '<strong>Si el producto está en stock en Alemania u otros almacenes:</strong> entre <strong>7 y 14 días laborables</strong>.',
          bmwNote: '(En productos originales BMW, la probabilidad de disponibilidad en Alemania u otros almacenes es del 90%.)',
          destinations: 'Los plazos indicados aplican a España, Portugal, Andorra y Francia. Para otros destinos los plazos pueden ser superiores.',
          specialConditions: '<strong>Condiciones especiales:</strong>',
          androidScreens: '• Las pantallas o módulos Android requieren entre <strong>7 y 14 días adicionales</strong> por su configuración personalizada.',
          bulkyProducts: '• Los productos voluminosos o de logística especial pueden tardar un poco más.',
          disclaimer: '<em>Estos tiempos son orientativos. Puede haber pequeñas demoras por alta demanda o procesos aduaneros. En cualquier caso, el plazo máximo de entrega es de <strong>30 días naturales para España</strong> y <strong>90 días naturales para envíos internacionales</strong>.</em>',
          reassurance: 'Tranquilidad ante todo: tu pedido está en curso y te avisaremos en cuanto pase al siguiente paso'
        },
        cancel: {
          title: '¿Puedo cancelar mi pedido?',
          beforeReceiving: '<strong>Antes de recibir el paquete:</strong><br> Nuestros procesos son automáticos y rápidos. Una vez iniciado el envío, no es posible cancelarlo, pero podrás devolverlo fácilmente al recibirlo.',
          within14Days: '<strong>Después de recibirlo (hasta 14 días):</strong><br> Puedes ejercer tu derecho de desistimiento. Se reembolsará el importe en el mismo método de pago, descontando los gastos de envío (ida y vuelta).',
          between15And30Days: '<strong>Entre 15 y 30 días desde la entrega:</strong><br> Te ofrecemos una opción extra: <strong>tarjeta regalo del 50% del importe</strong>, siempre que el producto esté sin usar y en perfecto estado.',
          shippingCostNote: '<em>Aunque el envío fuera "gratuito", esos gastos existen y se descuentan igualmente según tarifa.</em>',
          helpNote: '<em>Estamos para ayudarte: si tienes dudas, contáctanos y te orientaremos en tu caso concreto.</em>'
        },
        notReceived: {
          title: '¿No lo has recibido aún?',
          intro: 'Antes de preocuparte, revisa estos puntos',
          checkPoints: '• Buzón, portería o recepción del edificio.<br>• Balcón, jardín o patio (a veces lo dejan discretamente).<br>• Familiares, compañeros o vecinos (entrega alternativa habitual).',
          contactMessage: 'Si tras comprobarlo no aparece, <strong>contáctanos por WhatsApp</strong> y lo revisaremos <strong>al instante</strong>:',
          whatsappLink: '<a href="https://api.whatsapp.com/send?phone=34616083226" target="_blank" rel="noopener">Abrir chat en WhatsApp</a>',
          reassurance: '<em>Estamos aquí para que no tengas que preocuparte por nada.</em>'
        },
        compensation: {
          title: 'Detalle por demora estimada',
          delayDetected: 'Hemos detectado un pequeño retraso logístico, pero tu pedido <strong>sigue en curso y sin incidencias</strong>.',
          offer: 'Como agradecimiento por tu paciencia, te ofrecemos una <strong>tarjeta regalo de 3 €</strong> para tu próxima compra.',
          terms: 'Una por pedido. No acumulable. Válida 90 días.',
          requestButton: 'Solicitar tarjeta de 3 €',
          notNow: 'Ahora no'
        },
        carrierInfo: {
          title: '¿Por qué el transportista muestra "no recogido"?',
          dontWorry: 'No te preocupes, <strong>ya hemos entregado el paquete al transportista</strong>.',
          inTransit: 'Ahora se encuentra en tránsito hacia su <strong>centro logístico</strong>, donde será <strong>etiquetado, escaneado y registrado</strong>.',
          scanningNote: 'Hasta que se complete ese primer escaneo, la web del transportista puede mostrar "no recogido" o parecer sin movimiento.',
          autoUpdate: 'En cuanto se procese, <strong>el seguimiento se actualizará automáticamente</strong>.',
          reassurance: '<em>Tu pedido está en buenas manos y avanza correctamente.</em>'
        },
        material: {
          title: '¿Por qué aún no ha sido entregado al transportista?',
          intro: 'Es cierto que <strong>ya hemos recibido tu material</strong>, pero antes de enviarlo pasa por un proceso muy cuidadoso',
          step1: '<strong>1. Descarga y clasificación:</strong> se descargan los camiones y se ordenan los bultos por pedido.',
          step2: '<strong>2. Revisión de referencias:</strong> comprobamos una a una todas las piezas para asegurarnos de que coincidan y estén perfectas.',
          step3: '<strong>3. Preparación del envío:</strong> embalamos correctamente y asignamos el pedido al transportista.',
          currentPhase: '<em>Tu pedido está en esta fase final de control de calidad.</em>',
          soonPickup: '<em>En breve el transportista lo recogerá y recibirás el aviso de envío.</em>',
          thanks: '<em>Gracias por tu paciencia: todo va según lo previsto.</em>'
        }
      },
      incidents: {
        delay: {
          title: 'Retraso detectado',
          message: 'Tu envío registra un retraso puntual por parte del transportista.'
        },
        attempt: {
          title: 'Intento de entrega fallido',
          message: 'Se intentó la entrega y no fue posible completarla.'
        },
        address: {
          title: 'Problema con la dirección',
          message: 'Hay un problema con la dirección de entrega. Por favor, revísala.'
        },
        redirected: {
          title: 'Redirigido',
          message: 'El paquete ha sido redirigido a un punto de entrega alternativo.'
        },
        undeliverable: {
          title: 'No entregable',
          message: 'El transportista no ha podido completar la entrega.'
        },
        damaged: {
          title: 'Incidencia del transportista',
          message: 'Paquete dañado.'
        },
        lost: {
          title: 'Incidencia del transportista',
          message: 'Paquete extraviado.'
        },
        returned: {
          title: 'Devuelto',
          message: 'El paquete ha sido devuelto.'
        },
        partial: {
          title: 'Entrega parcial',
          message: 'Este pedido se sirve en varios bultos y podrían llegar en momentos distintos.'
        },
        outForDelivery: {
          title: '¡ATENCIÓN! En reparto HOY',
          message: 'Si no surge ninguna incidencia, la entrega se realizará HOY. Rogamos que haya alguien en el domicilio para recibir el paquete. Si no fuera posible, facilite autorización o alternativa de entrega al transportista.'
        }
      },
      schema: {
        defaultText: 'Pedido en proceso.',
        pickedUp: 'Paquete recogido por el transportista. En tránsito.',
        outForDelivery: 'En reparto hoy. Mantente atento a la entrega.',
        deliveryAttempt: 'Intento de entrega no completado.',
        delayed: 'Retraso detectado por parte del transportista.',
        redirected: 'Disponible para recogida o redirigido a punto de entrega.',
        addressError: 'Problema con la dirección de entrega.',
        undeliverable: 'Envío no entregable. Requiere gestión.',
        damaged: 'Incidencia: paquete dañado.',
        lost: 'Incidencia: paquete extraviado.',
        returned: 'Devolución en curso o completada.',
        partiallyDelivered: 'Entrega parcial: varios bultos podrían llegar en momentos distintos.',
        pending: 'Pedido registrado. Pendiente de movimiento inicial.'
      },
      footer: {
        disclaimer: 'Sitio web independiente. No afiliado ni autorizado por BMW AG, MINI ni BMW Motorrad.',
        shopName: 'Recambios y accesorios originales y compatibles para tu BMW, MINI y Motorrad',
        newsletterHeading: 'Las mejores ofertas y noticias de <strong>BMW, MINI y Motorrad</strong>, directo a tu correo.'
      },
      countries: {
        germany: 'Alemania',
        spain: 'España',
        destination: 'Destino'
      },
      product: {
        saleBadge: (window.__themeConfig && window.__themeConfig.promoBadges && window.__themeConfig.promoBadges.es) || '',
        startingAt: 'A partir de'
      },
      reviews: {
        trustpilotText: 'En Trustpilot',
        safeBrowsingStatus: 'Sitio seguro'
      }
    },
    en: {
      copy: 'Copy',
      copied: 'Copied',
      close: 'Close',
      retry: 'Retry',
      searching: 'Searching…',
      understood: 'Understood',
      notNow: 'Not now',
      shippingRateEstimator: {
        title: 'Calculate the actual shipping cost',
        hint: 'It depends on the country, postcode and items in your cart.',
        country: 'Country',
        postcode: 'Postcode',
        province: 'State/region (if required)',
        button: 'CALCULATE SHIPPING',
        loading: 'Calculating current rates…',
        result: 'Available options',
        none: 'No shipping rate is available for this address.',
        error: 'Unable to calculate. Check the postcode or try again.'
      },
      faqTitle: 'Frequently Asked Questions',
      productAi: {
        title: 'Have a question about this product?',
        subtitle: 'Our intelligent assistant responds instantly with real product information.',
        placeholder: 'Ask...',
        button: 'Ask',
        errorResponse: 'Could not get a response. Try again.',
        errorConnection: 'Connection error. Check your network.',
        loading: [
          'Analyzing your question…',
          'Consulting BMW catalogs…',
          'Accelerating response…',
          'Verifying compatibility…',
          'Processing information…'
        ]
      },
      orderSteps: [
        { title: 'Order received', desc: 'Your purchase has been successfully registered and we have validated the order details.' },
        { title: 'Request in progress', desc: 'We have requested the necessary material from our warehouses, BMW Germany, suppliers or associated workshops.' },
        { title: 'In transit to our facilities', desc: 'The material is on its way to our (logistics) facilities for preparation.' },
        { title: 'Preparing your shipment', desc: 'We have received the material, we are checking the references and preparing the order for shipment.' },
        { title: 'Handed over to carrier', desc: 'Your order has already left our facilities and has been handed over to the carrier for shipping.' },
        { title: 'In transit', desc: 'The order is on its way to your address. You can track its route with the tracking number provided.' },
        { title: 'Delivered', desc: 'Your order has been successfully delivered! If you have any problem with it, do not hesitate to contact us.' }
      ],
      calmMessages: {
        created: [
          'We are preparing your order. No news = good sign',
          'Order validated and in preparation queue. All in order.',
          'Following the planned schedule. We will notify you as soon as it progresses.'
        ],
        created_stale: [
          'Complex orders take more time. Everything under control.',
          'We are managing the request. Patience and trust.',
          'The system updates regularly. We notify you of any news.'
        ],
        to_courier: [
          'Almost ready to go. The carrier will come soon.',
          'Coordinating pickup with the carrier. In the next few hours.',
          'Material ready. Just waiting for the carrier to come to our facilities.'
        ],
        shipped: [
          'Your order is on its way. Check the status on the carrier website.',
          'On the way to your address. Delivery time now depends on the carrier.',
          'Follow the tracking. If days pass without changes, contact us.'
        ],
        delivered: [
          'Your order arrived! Everything correct? We are here if you need help.',
          'Order delivered. If you or someone at your address signed for it, everything is in order.',
          'Thank you very much for your purchase. Any questions, contact us.'
        ]
      },
      shippingStatus: {
        outForDelivery: 'Out for delivery',
        deliveryAttempt: 'Delivery attempt',
        pickedUp: 'Picked up',
        delayed: 'Delayed',
        redirected: 'Redirected',
        pickupOffice: 'Available at office',
        undeliverable: 'Undeliverable',
        damaged: 'Damaged',
        lost: 'Lost',
        returned: 'Returned',
        rejected: 'Rejected',
        addressError: 'Address error',
        returnProblem: 'Return problem',
        partiallyShipped: 'Partially shipped',
        partiallyDelivered: 'Partially delivered',
        outForPickup: 'Ready for pickup',
        toCourier: 'Handing over to carrier',
        created: 'Created',
        information: 'Information',
        pending: 'Pending',
        na: 'N/A',
        shipped: 'Shipped',
        delivered: 'Delivered'
      },
      order: {
        deliveryInfoLink: 'But when will my order be delivered?',
        materialInfoLink: 'If you already have the material, why hasn\'t it been handed over to the carrier yet?',
        carrierInfoLink: 'Why does the carrier website say "not picked up"?',
        notReceivedButton: 'I haven\'t received it',
        carrierMoreInfo: 'More information on the carrier website:',
        businessDaysNote: '* Business days',
        returnPackageButton: 'Return package',
        cancelOrderButton: 'Cancel order'
      },
      whatsapp: {
        shipmentWithTracking: 'shipment {tracking}',
        shipmentNoTracking: 'shipment (no tracking number)',
        giftCardRequest: 'I would like to request the 3€ card'
      },
      ui: {
        progressBarLabel: 'Estimated order progress',
        loading: 'Searching…',
        errorMessage: 'An error occurred while checking the tracking.',
        speakToAgent: 'Speak to an agent',
        retry: 'Retry',
        state: 'State:',
        businessDaysElapsed: 'Days elapsed (business days)',
        tracking: 'Tracking',
        carrier: 'Carrier',
        status: 'Status',
        lastUpdate: 'Last update',
        recipient: 'Recipient',
        packages: 'Packages',
        copyTrackingLabel: 'Copy tracking number',
        compensationButton: 'We give you 3 € for waiting',
        helpbarMessage: 'If you have any questions, you can speak to an agent <a href="/pages/consulta-sobre-pedidos?Message=I%20need%20more%20information%20about%20the%20shipment" target="_blank" rel="noopener">by clicking here</a>.',
        bizDaysValue: '≈ {count} business days',
        bizDaysDisclaimer: 'The number of business days shown is approximate and may be lower: local, regional or national holidays are not included.'
      },
      legend: {
        completed: 'Completed',
        inProgress: 'In progress',
        pending: 'Pending'
      },
      modals: {
        delivery: {
          title: 'Estimated delivery times',
          intro: 'The estimated delivery time for orders is:',
          spainStock: '<strong>If the product is in stock in Spain:</strong> between <strong>2 and 7 business days</strong>.',
          germanyStock: '<strong>If the product is in stock in Germany or other warehouses:</strong> between <strong>7 and 14 business days</strong>.',
          bmwNote: '(For original BMW products, the probability of availability in Germany or other warehouses is 90%.)',
          destinations: 'The indicated times apply to Spain, Portugal, Andorra and France. For other destinations, delivery times may be longer.',
          specialConditions: '<strong>Special conditions:</strong>',
          androidScreens: '• Android screens or modules require between <strong>7 and 14 additional days</strong> due to their custom configuration.',
          bulkyProducts: '• Bulky products or those with special logistics may take a little longer.',
          disclaimer: '<em>These times are indicative. There may be small delays due to high demand or customs processes. In any case, the maximum delivery time is <strong>30 calendar days for Spain</strong> and <strong>90 calendar days for international shipments</strong>.</em>',
          reassurance: 'Peace of mind above all: your order is in progress and we will notify you as soon as it moves to the next step'
        },
        cancel: {
          title: 'Can I cancel my order?',
          beforeReceiving: '<strong>Before receiving the package:</strong><br> Our processes are automatic and fast. Once the shipment has been initiated, it is not possible to cancel it, but you can easily return it when you receive it.',
          within14Days: '<strong>After receiving it (up to 14 days):</strong><br> You can exercise your right of withdrawal. The amount will be refunded to the same payment method, deducting shipping costs (round trip).',
          between15And30Days: '<strong>Between 15 and 30 days from delivery:</strong><br> We offer you an extra option: <strong>gift card for 50% of the amount</strong>, as long as the product is unused and in perfect condition.',
          shippingCostNote: '<em>Even if the shipment was "free", these costs exist and are deducted equally according to the rate.</em>',
          helpNote: '<em>We are here to help you: if you have doubts, contact us and we will guide you in your specific case.</em>'
        },
        notReceived: {
          title: 'Haven\'t received it yet?',
          intro: 'Before worrying, check these points',
          checkPoints: '• Mailbox, concierge or building reception.<br>• Balcony, garden or patio (sometimes left discreetly).<br>• Family, colleagues or neighbors (usual alternative delivery).',
          contactMessage: 'If after checking it doesn\'t appear, <strong>contact us via WhatsApp</strong> and we will check it <strong>instantly</strong>:',
          whatsappLink: '<a href="https://api.whatsapp.com/send?phone=34616083226" target="_blank" rel="noopener">Open WhatsApp chat</a>',
          reassurance: '<em>We are here so you don\'t have to worry about anything.</em>'
        },
        compensation: {
          title: 'Compensation for estimated delay',
          delayDetected: 'We have detected a small logistics delay, but your order <strong>continues in progress without incidents</strong>.',
          offer: 'As a thank you for your patience, we offer you a <strong>3 € gift card</strong> for your next purchase.',
          terms: 'One per order. Not combinable. Valid for 90 days.',
          requestButton: 'Request 3 € card',
          notNow: 'Not now'
        },
        carrierInfo: {
          title: 'Why does the carrier show "not picked up"?',
          dontWorry: 'Don\'t worry, <strong>we have already handed the package to the carrier</strong>.',
          inTransit: 'It is now in transit to their <strong>logistics center</strong>, where it will be <strong>labeled, scanned and registered</strong>.',
          scanningNote: 'Until that first scan is completed, the carrier website may show "not picked up" or appear without movement.',
          autoUpdate: 'As soon as it is processed, <strong>tracking will update automatically</strong>.',
          reassurance: '<em>Your order is in good hands and progressing correctly.</em>'
        },
        material: {
          title: 'Why hasn\'t it been handed over to the carrier yet?',
          intro: 'It\'s true that <strong>we have already received your material</strong>, but before sending it it goes through a very careful process',
          step1: '<strong>1. Unloading and classification:</strong> trucks are unloaded and packages are sorted by order.',
          step2: '<strong>2. Reference check:</strong> we check all the pieces one by one to make sure they match and are perfect.',
          step3: '<strong>3. Shipment preparation:</strong> we pack correctly and assign the order to the carrier.',
          currentPhase: '<em>Your order is in this final quality control phase.</em>',
          soonPickup: '<em>Soon the carrier will pick it up and you will receive the shipping notice.</em>',
          thanks: '<em>Thank you for your patience: everything is going as planned.</em>'
        }
      },
      incidents: {
        delay: {
          title: 'Delay detected',
          message: 'Your shipment has a temporary delay by the carrier.'
        },
        attempt: {
          title: 'Failed delivery attempt',
          message: 'Delivery was attempted and could not be completed.'
        },
        address: {
          title: 'Address problem',
          message: 'There is a problem with the delivery address. Please check it.'
        },
        redirected: {
          title: 'Redirected',
          message: 'The package has been redirected to an alternative delivery point.'
        },
        undeliverable: {
          title: 'Undeliverable',
          message: 'The carrier has not been able to complete the delivery.'
        },
        damaged: {
          title: 'Carrier incident',
          message: 'Package damaged.'
        },
        lost: {
          title: 'Carrier incident',
          message: 'Package lost.'
        },
        returned: {
          title: 'Returned',
          message: 'The package has been returned.'
        },
        partial: {
          title: 'Partial delivery',
          message: 'This order is served in several packages and could arrive at different times.'
        },
        outForDelivery: {
          title: 'ATTENTION! Out for delivery TODAY',
          message: 'If no incident arises, delivery will be made TODAY. Please have someone at the address to receive the package. If this is not possible, provide authorization or alternative delivery to the carrier.'
        }
      },
      schema: {
        defaultText: 'Order in process.',
        pickedUp: 'Package picked up by carrier. In transit.',
        outForDelivery: 'Out for delivery today. Stay alert for delivery.',
        deliveryAttempt: 'Delivery attempt not completed.',
        delayed: 'Delay detected by carrier.',
        redirected: 'Available for pickup or redirected to delivery point.',
        addressError: 'Problem with delivery address.',
        undeliverable: 'Shipment undeliverable. Requires management.',
        damaged: 'Incident: damaged package.',
        lost: 'Incident: lost package.',
        returned: 'Return in progress or completed.',
        partiallyDelivered: 'Partial delivery: multiple packages may arrive at different times.',
        pending: 'Order registered. Pending initial movement.'
      },
      footer: {
        disclaimer: 'Independent website. Not affiliated with or authorized by BMW AG, MINI or BMW Motorrad.',
        shopName: 'Original and compatible spare parts and accessories for your BMW, MINI and Motorrad',
        newsletterHeading: 'The best deals and news about <strong>BMW, MINI and Motorrad</strong>, straight to your inbox.'
      },
      countries: {
        germany: 'Germany',
        spain: 'Spain',
        destination: 'Destination'
      },
      product: {
        saleBadge: (window.__themeConfig && window.__themeConfig.promoBadges && window.__themeConfig.promoBadges.en) || '',
        startingAt: 'Starting at'
      },
      reviews: {
        trustpilotText: 'On Trustpilot',
        safeBrowsingStatus: 'Secure site'
      }
    },
    de: {
      copy: 'Kopieren',
      copied: 'Kopiert',
      close: 'Schließen',
      retry: 'Wiederholen',
      searching: 'Suche läuft…',
      understood: 'Verstanden',
      notNow: 'Nicht jetzt',
      shippingRateEstimator: {
        title: 'Tatsächliche Versandkosten berechnen',
        hint: 'Sie hängen von Land, Postleitzahl und Warenkorb ab.',
        country: 'Land',
        postcode: 'Postleitzahl',
        province: 'Bundesland/Region (falls nötig)',
        button: 'VERSAND BERECHNEN',
        loading: 'Aktuelle Tarife werden berechnet…',
        result: 'Verfügbare Optionen',
        none: 'Für diese Adresse ist kein Tarif verfügbar.',
        error: 'Die Berechnung war nicht möglich. Bitte prüfen Sie die Postleitzahl.'
      },
      faqTitle: 'Häufig gestellte Fragen',
      productAi: {
        title: 'Haben Sie eine Frage zu diesem Produkt?',
        subtitle: 'Unser intelligenter Assistent antwortet sofort mit echten Produktinformationen.',
        placeholder: 'Fragen...',
        button: 'Fragen',
        errorResponse: 'Keine Antwort erhalten. Versuchen Sie es erneut.',
        errorConnection: 'Verbindungsfehler. Überprüfen Sie Ihr Netzwerk.',
        loading: [
          'Analysiere Ihre Frage…',
          'Konsultiere BMW-Kataloge…',
          'Beschleunige Antwort…',
          'Überprüfe Kompatibilität…',
          'Verarbeite Informationen…'
        ]
      },
      orderSteps: [
        { title: 'Bestellung eingegangen', desc: 'Ihr Kauf wurde erfolgreich registriert und wir haben die Bestelldetails validiert.' },
        { title: 'Anfrage läuft', desc: 'Wir haben das notwendige Material von unseren Lagern, BMW Deutschland, Lieferanten oder assoziierten Werkstätten angefordert.' },
        { title: 'Unterwegs zu unseren Einrichtungen', desc: 'Das Material ist auf dem Weg zu unseren (Logistik-)Einrichtungen zur Vorbereitung.' },
        { title: 'Vorbereitung Ihrer Sendung', desc: 'Wir haben das Material erhalten, überprüfen die Referenzen und bereiten die Bestellung für den Versand vor.' },
        { title: 'An Spediteur übergeben', desc: 'Ihre Bestellung hat bereits unsere Einrichtungen verlassen und wurde an den Spediteur zum Versand übergeben.' },
        { title: 'Unterwegs', desc: 'Die Bestellung ist auf dem Weg zu Ihrer Adresse. Sie können ihre Route mit der bereitgestellten Sendungsnummer verfolgen.' },
        { title: 'Zugestellt', desc: 'Ihre Bestellung wurde erfolgreich zugestellt! Wenn Sie ein Problem damit haben, zögern Sie nicht, uns zu kontaktieren.' }
      ],
      calmMessages: {
        created: [
          'Wir bereiten Ihre Bestellung vor. Keine Neuigkeiten = gutes Zeichen',
          'Bestellung validiert und in Vorbereitungswarteschlange. Alles in Ordnung.',
          'Folgen dem geplanten Zeitplan. Wir benachrichtigen Sie, sobald es Fortschritte gibt.'
        ],
        created_stale: [
          'Komplexe Bestellungen brauchen mehr Zeit. Alles unter Kontrolle.',
          'Wir bearbeiten die Anfrage. Geduld und Vertrauen.',
          'Das System aktualisiert sich regelmäßig. Wir benachrichtigen Sie bei Neuigkeiten.'
        ],
        to_courier: [
          'Fast fertig zum Versand. Der Spediteur kommt bald.',
          'Koordinieren Abholung mit dem Spediteur. In den nächsten Stunden.',
          'Material bereit. Warten nur darauf, dass der Spediteur zu unseren Einrichtungen kommt.'
        ],
        shipped: [
          'Ihre Bestellung ist unterwegs. Überprüfen Sie den Status auf der Spediteur-Website.',
          'Auf dem Weg zu Ihrer Adresse. Die Lieferzeit hängt jetzt vom Spediteur ab.',
          'Folgen Sie der Sendungsverfolgung. Wenn Tage ohne Änderungen vergehen, kontaktieren Sie uns.'
        ],
        delivered: [
          'Ihre Bestellung ist angekommen! Alles korrekt? Wir sind hier, wenn Sie Hilfe benötigen.',
          'Bestellung zugestellt. Wenn Sie oder jemand an Ihrer Adresse dafür unterschrieben hat, ist alles in Ordnung.',
          'Vielen Dank für Ihren Kauf. Bei Fragen kontaktieren Sie uns.'
        ]
      },
      shippingStatus: {
        outForDelivery: 'Zur Zustellung unterwegs',
        deliveryAttempt: 'Zustellversuch',
        pickedUp: 'Abgeholt',
        delayed: 'Verspätet',
        redirected: 'Umgeleitet',
        pickupOffice: 'Im Büro verfügbar',
        undeliverable: 'Nicht zustellbar',
        damaged: 'Beschädigt',
        lost: 'Verloren',
        returned: 'Zurückgeschickt',
        rejected: 'Abgelehnt',
        addressError: 'Adressfehler',
        returnProblem: 'Rücksendeproblem',
        partiallyShipped: 'Teilweise versandt',
        partiallyDelivered: 'Teilweise zugestellt',
        outForPickup: 'Abholbereit',
        toCourier: 'Übergabe an Spediteur',
        created: 'Erstellt',
        information: 'Information',
        pending: 'Ausstehend',
        na: 'N/V',
        shipped: 'Versandt',
        delivered: 'Zugestellt'
      },
      order: {
        deliveryInfoLink: 'Aber wann wird meine Bestellung geliefert?',
        materialInfoLink: 'Wenn Sie das Material bereits haben, warum wurde es noch nicht an den Spediteur übergeben?',
        carrierInfoLink: 'Warum steht auf der Spediteur-Website "nicht abgeholt"?',
        notReceivedButton: 'Ich habe es nicht erhalten',
        carrierMoreInfo: 'Weitere Informationen auf der Spediteur-Website:',
        businessDaysNote: '* Werktage',
        returnPackageButton: 'Paket zurücksenden',
        cancelOrderButton: 'Bestellung stornieren'
      },
      whatsapp: {
        shipmentWithTracking: 'Sendung {tracking}',
        shipmentNoTracking: 'Sendung (keine Sendungsnummer)',
        giftCardRequest: 'Ich möchte die 3€-Karte anfordern'
      },
      ui: {
        progressBarLabel: 'Geschätzter Bestellfortschritt',
        loading: 'Suche läuft…',
        errorMessage: 'Beim Überprüfen der Sendungsverfolgung ist ein Fehler aufgetreten.',
        speakToAgent: 'Mit einem Mitarbeiter sprechen',
        retry: 'Wiederholen',
        state: 'Status:',
        businessDaysElapsed: 'Vergangene Tage (Werktage)',
        tracking: 'Sendungsverfolgung',
        carrier: 'Spediteur',
        status: 'Status',
        lastUpdate: 'Letzte Aktualisierung',
        recipient: 'Empfänger',
        packages: 'Pakete',
        copyTrackingLabel: 'Sendungsnummer kopieren',
        compensationButton: 'Wir schenken Ihnen 3 € fürs Warten',
        helpbarMessage: 'Wenn Sie Fragen haben, können Sie mit einem Mitarbeiter sprechen <a href="/pages/consulta-sobre-pedidos?Message=Ich%20ben%C3%B6tige%20weitere%20Informationen%20zur%20Sendung" target="_blank" rel="noopener">indem Sie hier klicken</a>.',
        bizDaysValue: '≈ {count} Werktage',
        bizDaysDisclaimer: 'Die angegebene Anzahl der Werktage ist ungefähr und kann niedriger sein: Lokale, regionale oder nationale Feiertage sind nicht berücksichtigt.'
      },
      legend: {
        completed: 'Abgeschlossen',
        inProgress: 'Läuft',
        pending: 'Ausstehend'
      },
      modals: {
        delivery: {
          title: 'Geschätzte Lieferzeiten',
          intro: 'Die geschätzte Lieferzeit für Bestellungen beträgt:',
          spainStock: '<strong>Wenn das Produkt in Spanien vorrätig ist:</strong> zwischen <strong>2 und 7 Werktagen</strong>.',
          germanyStock: '<strong>Wenn das Produkt in Deutschland oder anderen Lagern vorrätig ist:</strong> zwischen <strong>7 und 14 Werktagen</strong>.',
          bmwNote: '(Bei Original-BMW-Produkten liegt die Wahrscheinlichkeit der Verfügbarkeit in Deutschland oder anderen Lagern bei 90%.)',
          destinations: 'Die angegebenen Zeiten gelten für Spanien, Portugal, Andorra und Frankreich. Für andere Ziele können die Lieferzeiten länger sein.',
          specialConditions: '<strong>Sonderbedingungen:</strong>',
          androidScreens: '• Android-Bildschirme oder -Module benötigen zwischen <strong>7 und 14 zusätzlichen Tagen</strong> aufgrund ihrer individuellen Konfiguration.',
          bulkyProducts: '• Sperrige Produkte oder solche mit besonderer Logistik können etwas länger dauern.',
          disclaimer: '<em>Diese Zeiten sind Richtwerte. Es kann zu kleinen Verzögerungen aufgrund hoher Nachfrage oder Zollprozessen kommen. In jedem Fall beträgt die maximale Lieferzeit <strong>30 Kalendertage für Spanien</strong> und <strong>90 Kalendertage für internationale Sendungen</strong>.</em>',
          reassurance: 'Ruhe vor allem: Ihre Bestellung läuft und wir benachrichtigen Sie, sobald sie zum nächsten Schritt übergeht'
        },
        cancel: {
          title: 'Kann ich meine Bestellung stornieren?',
          beforeReceiving: '<strong>Vor Erhalt des Pakets:</strong><br> Unsere Prozesse sind automatisch und schnell. Sobald der Versand begonnen hat, ist eine Stornierung nicht möglich, aber Sie können es bei Erhalt einfach zurücksenden.',
          within14Days: '<strong>Nach Erhalt (bis zu 14 Tage):</strong><br> Sie können Ihr Widerrufsrecht ausüben. Der Betrag wird auf dieselbe Zahlungsmethode zurückerstattet, abzüglich der Versandkosten (Hin- und Rückweg).',
          between15And30Days: '<strong>Zwischen 15 und 30 Tagen nach Lieferung:</strong><br> Wir bieten Ihnen eine zusätzliche Option: <strong>Geschenkkarte über 50% des Betrags</strong>, solange das Produkt unbenutzt und in perfektem Zustand ist.',
          shippingCostNote: '<em>Auch wenn der Versand "kostenlos" war, existieren diese Kosten und werden entsprechend der Tarife abgezogen.</em>',
          helpNote: '<em>Wir sind hier, um Ihnen zu helfen: Wenn Sie Zweifel haben, kontaktieren Sie uns und wir beraten Sie in Ihrem konkreten Fall.</em>'
        },
        notReceived: {
          title: 'Noch nicht erhalten?',
          intro: 'Bevor Sie sich Sorgen machen, überprüfen Sie diese Punkte',
          checkPoints: '• Briefkasten, Pförtner oder Gebäudeempfang.<br>• Balkon, Garten oder Terrasse (manchmal diskret abgestellt).<br>• Familie, Kollegen oder Nachbarn (übliche alternative Zustellung).',
          contactMessage: 'Wenn es nach der Überprüfung nicht auftaucht, <strong>kontaktieren Sie uns per WhatsApp</strong> und wir überprüfen es <strong>sofort</strong>:',
          whatsappLink: '<a href="https://api.whatsapp.com/send?phone=34616083226" target="_blank" rel="noopener">WhatsApp-Chat öffnen</a>',
          reassurance: '<em>Wir sind hier, damit Sie sich um nichts kümmern müssen.</em>'
        },
        compensation: {
          title: 'Entschädigung für geschätzte Verzögerung',
          delayDetected: 'Wir haben eine kleine logistische Verzögerung festgestellt, aber Ihre Bestellung <strong>läuft weiter ohne Vorfälle</strong>.',
          offer: 'Als Dankeschön für Ihre Geduld bieten wir Ihnen eine <strong>3 € Geschenkkarte</strong> für Ihren nächsten Einkauf an.',
          terms: 'Eine pro Bestellung. Nicht kombinierbar. Gültig für 90 Tage.',
          requestButton: '3 € Karte anfordern',
          notNow: 'Nicht jetzt'
        },
        carrierInfo: {
          title: 'Warum zeigt der Spediteur "nicht abgeholt" an?',
          dontWorry: 'Keine Sorge, <strong>wir haben das Paket bereits an den Spediteur übergeben</strong>.',
          inTransit: 'Es befindet sich jetzt auf dem Weg zu seinem <strong>Logistikzentrum</strong>, wo es <strong>etikettiert, gescannt und registriert</strong> wird.',
          scanningNote: 'Bis dieser erste Scan abgeschlossen ist, kann die Spediteur-Website "nicht abgeholt" anzeigen oder ohne Bewegung erscheinen.',
          autoUpdate: 'Sobald es verarbeitet wird, <strong>wird die Sendungsverfolgung automatisch aktualisiert</strong>.',
          reassurance: '<em>Ihre Bestellung ist in guten Händen und schreitet korrekt voran.</em>'
        },
        material: {
          title: 'Warum wurde es noch nicht an den Spediteur übergeben?',
          intro: 'Es stimmt, dass <strong>wir Ihr Material bereits erhalten haben</strong>, aber bevor wir es versenden, durchläuft es einen sehr sorgfältigen Prozess',
          step1: '<strong>1. Entladung und Klassifizierung:</strong> LKWs werden entladen und Pakete nach Bestellung sortiert.',
          step2: '<strong>2. Referenzprüfung:</strong> Wir überprüfen alle Teile einzeln, um sicherzustellen, dass sie übereinstimmen und perfekt sind.',
          step3: '<strong>3. Versandvorbereitung:</strong> Wir verpacken korrekt und weisen die Bestellung dem Spediteur zu.',
          currentPhase: '<em>Ihre Bestellung befindet sich in dieser finalen Qualitätskontrollphase.</em>',
          soonPickup: '<em>Bald wird der Spediteur sie abholen und Sie erhalten die Versandbenachrichtigung.</em>',
          thanks: '<em>Vielen Dank für Ihre Geduld: Alles läuft wie geplant.</em>'
        }
      },
      incidents: {
        delay: {
          title: 'Verzögerung festgestellt',
          message: 'Ihre Sendung hat eine vorübergehende Verzögerung durch den Spediteur.'
        },
        attempt: {
          title: 'Fehlgeschlagener Zustellversuch',
          message: 'Zustellung wurde versucht und konnte nicht abgeschlossen werden.'
        },
        address: {
          title: 'Adressproblem',
          message: 'Es gibt ein Problem mit der Lieferadresse. Bitte überprüfen Sie sie.'
        },
        redirected: {
          title: 'Umgeleitet',
          message: 'Das Paket wurde an einen alternativen Zustellpunkt umgeleitet.'
        },
        undeliverable: {
          title: 'Nicht zustellbar',
          message: 'Der Spediteur konnte die Zustellung nicht abschließen.'
        },
        damaged: {
          title: 'Spediteur-Vorfall',
          message: 'Paket beschädigt.'
        },
        lost: {
          title: 'Spediteur-Vorfall',
          message: 'Paket verloren.'
        },
        returned: {
          title: 'Zurückgeschickt',
          message: 'Das Paket wurde zurückgeschickt.'
        },
        partial: {
          title: 'Teilweise Zustellung',
          message: 'Diese Bestellung wird in mehreren Paketen geliefert und könnte zu unterschiedlichen Zeiten ankommen.'
        },
        outForDelivery: {
          title: 'ACHTUNG! Heute zur Zustellung unterwegs',
          message: 'Wenn kein Vorfall auftritt, erfolgt die Zustellung HEUTE. Bitte stellen Sie sicher, dass jemand an der Adresse ist, um das Paket zu empfangen. Falls dies nicht möglich ist, geben Sie dem Spediteur eine Genehmigung oder alternative Zustellung an.'
        }
      },
      schema: {
        defaultText: 'Bestellung wird bearbeitet.',
        pickedUp: 'Paket vom Spediteur abgeholt. Unterwegs.',
        outForDelivery: 'Heute zur Zustellung. Bleiben Sie aufmerksam.',
        deliveryAttempt: 'Zustellversuch nicht abgeschlossen.',
        delayed: 'Verzögerung durch Spediteur festgestellt.',
        redirected: 'Zur Abholung bereit oder zu Zustellpunkt umgeleitet.',
        addressError: 'Problem mit Zustelladresse.',
        undeliverable: 'Sendung nicht zustellbar. Erfordert Verwaltung.',
        damaged: 'Vorfall: beschädigtes Paket.',
        lost: 'Vorfall: verlorenes Paket.',
        returned: 'Rücksendung läuft oder abgeschlossen.',
        partiallyDelivered: 'Teillieferung: mehrere Pakete können zu unterschiedlichen Zeiten ankommen.',
        pending: 'Bestellung registriert. Warten auf erste Bewegung.'
      },
      footer: {
        disclaimer: 'Unabhängige Website. Nicht von BMW AG, MINI oder BMW Motorrad autorisiert oder affiliiert.',
        shopName: 'Original- und kompatible Ersatzteile und Zubehör für Ihr BMW, MINI und Motorrad',
        newsletterHeading: 'Die besten Angebote und Neuigkeiten zu <strong>BMW, MINI und Motorrad</strong>, direkt in Ihr Postfach.'
      },
      countries: {
        germany: 'Deutschland',
        spain: 'Spanien',
        destination: 'Ziel'
      },
      product: {
        saleBadge: (window.__themeConfig && window.__themeConfig.promoBadges && window.__themeConfig.promoBadges.de) || '',
        startingAt: 'Ab'
      },
      reviews: {
        trustpilotText: 'Auf Trustpilot',
        safeBrowsingStatus: 'Sichere Website'
      }
    },
    fr: {
      copy: 'Copier',
      copied: 'Copié',
      close: 'Fermer',
      retry: 'Réessayer',
      searching: 'Recherche…',
      understood: 'Compris',
      notNow: 'Pas maintenant',
      shippingRateEstimator: {
        title: 'Calculer le coût réel de livraison',
        hint: 'Il dépend du pays, du code postal et du panier.',
        country: 'Pays',
        postcode: 'Code postal',
        province: 'Région/état (si nécessaire)',
        button: 'CALCULER LA LIVRAISON',
        loading: 'Calcul avec les tarifs actuels…',
        result: 'Options disponibles',
        none: 'Aucun tarif n\'est disponible pour cette adresse.',
        error: 'Calcul impossible. Vérifiez le code postal ou réessayez.'
      },
      faqTitle: 'Questions Fréquentes',
      productAi: {
        title: 'Vous avez une question sur ce produit ?',
        subtitle: 'Notre assistant intelligent répond instantanément avec de vraies informations sur le produit.',
        placeholder: 'Demander...',
        button: 'Demander',
        errorResponse: 'Impossible d\'obtenir une réponse. Réessayez.',
        errorConnection: 'Erreur de connexion. Vérifiez votre réseau.',
        loading: [
          'Analyse de votre question…',
          'Consultation des catalogues BMW…',
          'Accélération de la réponse…',
          'Vérification de la compatibilité…',
          'Traitement des informations…'
        ]
      },
      orderSteps: [
        { title: 'Commande reçue', desc: 'Votre achat a été enregistré avec succès et nous avons validé les détails de la commande.' },
        { title: 'Demande en cours', desc: 'Nous avons demandé le matériel nécessaire à nos entrepôts, BMW Allemagne, fournisseurs ou ateliers associés.' },
        { title: 'En transit vers nos installations', desc: 'Le matériel est en route vers nos installations (logistiques) pour préparation.' },
        { title: 'Préparation de votre envoi', desc: 'Nous avons reçu le matériel, nous vérifions les références et préparons la commande pour l\'expédition.' },
        { title: 'Remis au transporteur', desc: 'Votre commande a quitté nos installations et a été remise au transporteur pour expédition.' },
        { title: 'En transit', desc: 'La commande est en route vers votre adresse. Vous pouvez suivre son parcours avec le numéro de suivi fourni.' },
        { title: 'Livré', desc: 'Votre commande a été livrée avec succès ! Si vous avez un problème, n\'hésitez pas à nous contacter.' }
      ],
      calmMessages: {
        created: [
          'Nous préparons votre commande. Pas de nouvelles = bon signe',
          'Commande validée et en file d\'attente de préparation. Tout va bien.',
          'Nous suivons le calendrier prévu. Nous vous informerons dès qu\'il y aura du progrès.'
        ],
        created_stale: [
          'Les commandes complexes prennent plus de temps. Tout est sous contrôle.',
          'Nous gérons la demande. Patience et confiance.',
          'Le système se met à jour régulièrement. Nous vous informons de toute nouvelle.'
        ],
        to_courier: [
          'Presque prêt à partir. Le transporteur viendra bientôt.',
          'Coordination de l\'enlèvement avec le transporteur. Dans les prochaines heures.',
          'Matériel prêt. Il ne reste plus qu\'à attendre que le transporteur vienne à nos installations.'
        ],
        shipped: [
          'Votre commande est en route. Vérifiez l\'état sur le site du transporteur.',
          'En route vers votre adresse. Le délai de livraison dépend maintenant du transporteur.',
          'Suivez le suivi. Si des jours passent sans changement, contactez-nous.'
        ],
        delivered: [
          'Votre commande est arrivée ! Tout est correct ? Nous sommes là si vous avez besoin d\'aide.',
          'Commande livrée. Si vous ou quelqu\'un à votre adresse avez signé, tout va bien.',
          'Merci beaucoup pour votre achat. Pour toute question, contactez-nous.'
        ]
      },
      shippingStatus: {
        outForDelivery: 'En livraison',
        deliveryAttempt: 'Tentative de livraison',
        pickedUp: 'Récupéré',
        delayed: 'Retardé',
        redirected: 'Redirigé',
        pickupOffice: 'Disponible au bureau',
        undeliverable: 'Non livrable',
        damaged: 'Endommagé',
        lost: 'Perdu',
        returned: 'Retourné',
        rejected: 'Rejeté',
        addressError: 'Erreur d\'adresse',
        returnProblem: 'Problème de retour',
        partiallyShipped: 'Partiellement expédié',
        partiallyDelivered: 'Partiellement livré',
        outForPickup: 'Prêt pour enlèvement',
        toCourier: 'Remise au transporteur',
        created: 'Créé',
        information: 'Information',
        pending: 'En attente',
        na: 'N/A',
        shipped: 'Expédié',
        delivered: 'Livré'
      },
      order: {
        deliveryInfoLink: 'Mais quand ma commande sera-t-elle livrée ?',
        materialInfoLink: 'Si vous avez déjà le matériel, pourquoi n\'a-t-il pas encore été remis au transporteur ?',
        carrierInfoLink: 'Pourquoi le site du transporteur affiche "non récupéré" ?',
        notReceivedButton: 'Je ne l\'ai pas reçu',
        carrierMoreInfo: 'Plus d\'informations sur le site du transporteur :',
        businessDaysNote: '* Jours ouvrables',
        returnPackageButton: 'Retourner le colis',
        cancelOrderButton: 'Annuler la commande'
      },
      whatsapp: {
        shipmentWithTracking: 'de l\'envoi {tracking}',
        shipmentNoTracking: 'de l\'envoi (sans numéro de suivi)',
        giftCardRequest: 'Je voudrais demander la carte de 3€'
      },
      ui: {
        progressBarLabel: 'Progression estimée de la commande',
        loading: 'Recherche…',
        errorMessage: 'Une erreur s\'est produite lors de la vérification du suivi.',
        speakToAgent: 'Parler à un agent',
        retry: 'Réessayer',
        state: 'État :',
        businessDaysElapsed: 'Jours écoulés (jours ouvrables)',
        tracking: 'Suivi',
        carrier: 'Transporteur',
        status: 'Statut',
        lastUpdate: 'Dernière mise à jour',
        recipient: 'Destinataire',
        packages: 'Colis',
        copyTrackingLabel: 'Copier le numéro de suivi',
        compensationButton: 'Nous vous offrons 3 € pour l\'attente',
        helpbarMessage: 'Si vous avez des questions, vous pouvez parler à un agent <a href="/pages/consulta-sobre-pedidos?Message=J%27ai%20besoin%20de%20plus%20d%27informations%20sur%20l%27envoi" target="_blank" rel="noopener">en cliquant ici</a>.',
        bizDaysValue: '≈ {count} jours ouvrables',
        bizDaysDisclaimer: 'Le nombre de jours ouvrables indiqué est approximatif et peut être inférieur : les jours fériés locaux, régionaux ou nationaux ne sont pas pris en compte.'
      },
      legend: {
        completed: 'Terminé',
        inProgress: 'En cours',
        pending: 'En attente'
      },
      modals: {
        delivery: {
          title: 'Délais de livraison estimés',
          intro: 'Le délai de livraison estimé pour les commandes est :',
          spainStock: '<strong>Si le produit est en stock en Espagne :</strong> entre <strong>2 et 7 jours ouvrables</strong>.',
          germanyStock: '<strong>Si le produit est en stock en Allemagne ou autres entrepôts :</strong> entre <strong>7 et 14 jours ouvrables</strong>.',
          bmwNote: '(Pour les produits BMW d\'origine, la probabilité de disponibilité en Allemagne ou autres entrepôts est de 90 %.)',
          destinations: 'Les délais indiqués s\'appliquent à l\'Espagne, au Portugal, à Andorre et à la France. Pour d\'autres destinations, les délais peuvent être plus longs.',
          specialConditions: '<strong>Conditions spéciales :</strong>',
          androidScreens: '• Les écrans ou modules Android nécessitent entre <strong>7 et 14 jours supplémentaires</strong> en raison de leur configuration personnalisée.',
          bulkyProducts: '• Les produits volumineux ou à logistique spéciale peuvent prendre un peu plus de temps.',
          disclaimer: '<em>Ces délais sont indicatifs. Il peut y avoir de petits retards en raison d\'une forte demande ou de processus douaniers. En tout cas, le délai maximum de livraison est de <strong>30 jours calendaires pour l\'Espagne</strong> et <strong>90 jours calendaires pour les envois internationaux</strong>.</em>',
          reassurance: 'Tranquillité d\'esprit avant tout : votre commande est en cours et nous vous informerons dès qu\'elle passera à l\'étape suivante'
        },
        cancel: {
          title: 'Puis-je annuler ma commande ?',
          beforeReceiving: '<strong>Avant de recevoir le colis :</strong><br> Nos processus sont automatiques et rapides. Une fois l\'expédition lancée, il n\'est pas possible de l\'annuler, mais vous pouvez facilement le retourner lorsque vous le recevez.',
          within14Days: '<strong>Après réception (jusqu\'à 14 jours) :</strong><br> Vous pouvez exercer votre droit de rétractation. Le montant sera remboursé par le même mode de paiement, déduction faite des frais d\'expédition (aller-retour).',
          between15And30Days: '<strong>Entre 15 et 30 jours après la livraison :</strong><br> Nous vous offrons une option supplémentaire : <strong>carte cadeau de 50 % du montant</strong>, tant que le produit est inutilisé et en parfait état.',
          shippingCostNote: '<em>Même si l\'expédition était "gratuite", ces frais existent et sont déduits de la même manière selon le tarif.</em>',
          helpNote: '<em>Nous sommes là pour vous aider : si vous avez des doutes, contactez-nous et nous vous guiderons dans votre cas spécifique.</em>'
        },
        notReceived: {
          title: 'Vous ne l\'avez pas encore reçu ?',
          intro: 'Avant de vous inquiéter, vérifiez ces points',
          checkPoints: '• Boîte aux lettres, concierge ou réception de l\'immeuble.<br>• Balcon, jardin ou patio (parfois laissé discrètement).<br>• Famille, collègues ou voisins (livraison alternative habituelle).',
          contactMessage: 'Si après vérification il n\'apparaît pas, <strong>contactez-nous via WhatsApp</strong> et nous vérifierons <strong>instantanément</strong> :',
          whatsappLink: '<a href="https://api.whatsapp.com/send?phone=34616083226" target="_blank" rel="noopener">Ouvrir le chat WhatsApp</a>',
          reassurance: '<em>Nous sommes là pour que vous n\'ayez à vous inquiéter de rien.</em>'
        },
        compensation: {
          title: 'Compensation pour retard estimé',
          delayDetected: 'Nous avons détecté un petit retard logistique, mais votre commande <strong>se poursuit sans incident</strong>.',
          offer: 'En remerciement de votre patience, nous vous offrons une <strong>carte cadeau de 3 €</strong> pour votre prochain achat.',
          terms: 'Un par commande. Non cumulable. Valable 90 jours.',
          requestButton: 'Demander la carte de 3 €',
          notNow: 'Pas maintenant'
        },
        carrierInfo: {
          title: 'Pourquoi le transporteur affiche "non récupéré" ?',
          dontWorry: 'Ne vous inquiétez pas, <strong>nous avons déjà remis le colis au transporteur</strong>.',
          inTransit: 'Il est maintenant en transit vers leur <strong>centre logistique</strong>, où il sera <strong>étiqueté, scanné et enregistré</strong>.',
          scanningNote: 'Jusqu\'à ce que ce premier scan soit terminé, le site du transporteur peut afficher "non récupéré" ou sembler sans mouvement.',
          autoUpdate: 'Dès qu\'il sera traité, <strong>le suivi sera mis à jour automatiquement</strong>.',
          reassurance: '<em>Votre commande est entre de bonnes mains et progresse correctement.</em>'
        },
        material: {
          title: 'Pourquoi n\'a-t-il pas encore été remis au transporteur ?',
          intro: 'Il est vrai que <strong>nous avons déjà reçu votre matériel</strong>, mais avant de l\'envoyer, il passe par un processus très minutieux',
          step1: '<strong>1. Déchargement et classification :</strong> les camions sont déchargés et les colis sont triés par commande.',
          step2: '<strong>2. Vérification des références :</strong> nous vérifions toutes les pièces une par une pour nous assurer qu\'elles correspondent et sont parfaites.',
          step3: '<strong>3. Préparation de l\'envoi :</strong> nous emballons correctement et attribuons la commande au transporteur.',
          currentPhase: '<em>Votre commande est dans cette phase finale de contrôle qualité.</em>',
          soonPickup: '<em>Bientôt, le transporteur viendra le chercher et vous recevrez l\'avis d\'expédition.</em>',
          thanks: '<em>Merci pour votre patience : tout se déroule comme prévu.</em>'
        }
      },
      incidents: {
        delay: {
          title: 'Retard détecté',
          message: 'Votre envoi enregistre un retard temporaire par le transporteur.'
        },
        attempt: {
          title: 'Tentative de livraison échouée',
          message: 'La livraison a été tentée et n\'a pas pu être complétée.'
        },
        address: {
          title: 'Problème d\'adresse',
          message: 'Il y a un problème avec l\'adresse de livraison. Veuillez la vérifier.'
        },
        redirected: {
          title: 'Redirigé',
          message: 'Le colis a été redirigé vers un point de livraison alternatif.'
        },
        undeliverable: {
          title: 'Non livrable',
          message: 'Le transporteur n\'a pas pu terminer la livraison.'
        },
        damaged: {
          title: 'Incident du transporteur',
          message: 'Colis endommagé.'
        },
        lost: {
          title: 'Incident du transporteur',
          message: 'Colis perdu.'
        },
        returned: {
          title: 'Retourné',
          message: 'Le colis a été retourné.'
        },
        partial: {
          title: 'Livraison partielle',
          message: 'Cette commande est livrée en plusieurs colis et pourrait arriver à des moments différents.'
        },
        outForDelivery: {
          title: 'ATTENTION ! En livraison AUJOURD\'HUI',
          message: 'Si aucun incident ne survient, la livraison sera effectuée AUJOURD\'HUI. Veuillez qu\'il y ait quelqu\'un à l\'adresse pour recevoir le colis. Si ce n\'est pas possible, fournissez une autorisation ou une livraison alternative au transporteur.'
        }
      },
      schema: {
        defaultText: 'Commande en cours de traitement.',
        pickedUp: 'Colis récupéré par le transporteur. En transit.',
        outForDelivery: 'En livraison aujourd\'hui. Restez attentif à la livraison.',
        deliveryAttempt: 'Tentative de livraison non complétée.',
        delayed: 'Retard détecté par le transporteur.',
        redirected: 'Disponible pour enlèvement ou redirigé vers le point de livraison.',
        addressError: 'Problème avec l\'adresse de livraison.',
        undeliverable: 'Envoi non livrable. Nécessite une gestion.',
        damaged: 'Incident : colis endommagé.',
        lost: 'Incident : colis perdu.',
        returned: 'Retour en cours ou terminé.',
        partiallyDelivered: 'Livraison partielle : plusieurs colis peuvent arriver à des moments différents.',
        pending: 'Commande enregistrée. En attente de mouvement initial.'
      },
      footer: {
        disclaimer: 'Site web indépendant. Non affilié ou autorisé par BMW AG, MINI ou BMW Motorrad.',
        shopName: 'Pièces détachées et accessoires originaux et compatibles pour votre BMW, MINI et Motorrad',
        newsletterHeading: 'Les meilleures offres et actualités <strong>BMW, MINI et Motorrad</strong>, directement dans votre boîte mail.'
      },
      countries: {
        germany: 'Allemagne',
        spain: 'Espagne',
        destination: 'Destination'
      },
      product: {
        saleBadge: (window.__themeConfig && window.__themeConfig.promoBadges && window.__themeConfig.promoBadges.fr) || '',
        startingAt: 'À partir de'
      },
      reviews: {
        trustpilotText: 'Sur Trustpilot',
        safeBrowsingStatus: 'Site sécurisé'
      }
    },
    it: {
      copy: 'Copia',
      copied: 'Copiato',
      close: 'Chiudi',
      retry: 'Riprova',
      searching: 'Ricerca…',
      understood: 'Capito',
      notNow: 'Non ora',
      shippingRateEstimator: {
        title: 'Calcola il costo reale della spedizione',
        hint: 'Dipende dal paese, dal CAP e dai prodotti nel carrello.',
        country: 'Paese',
        postcode: 'CAP',
        province: 'Provincia/stato (se necessario)',
        button: 'CALCOLA SPEDIZIONE',
        loading: 'Calcolo con le tariffe attuali…',
        result: 'Opzioni disponibili',
        none: 'Nessuna tariffa disponibile per questo indirizzo.',
        error: 'Impossibile calcolare. Controlla il CAP o riprova.'
      },
      faqTitle: 'Domande Frequenti',
      productAi: {
        title: 'Hai una domanda su questo prodotto?',
        subtitle: 'Il nostro assistente intelligente risponde immediatamente con informazioni reali sul prodotto.',
        placeholder: 'Chiedi...',
        button: 'Chiedi',
        errorResponse: 'Impossibile ottenere una risposta. Riprova.',
        errorConnection: 'Errore di connessione. Verifica la tua rete.',
        loading: [
          'Analizzando la tua domanda…',
          'Consultando i cataloghi BMW…',
          'Accelerando la risposta…',
          'Verificando la compatibilità…',
          'Elaborando informazioni…'
        ]
      },
      orderSteps: [
        { title: 'Ordine ricevuto', desc: 'Il tuo acquisto è stato registrato con successo e abbiamo convalidato i dettagli dell\'ordine.' },
        { title: 'Richiesta in corso', desc: 'Abbiamo richiesto il materiale necessario ai nostri magazzini, BMW Germania, fornitori o officine associate.' },
        { title: 'In transito verso le nostre strutture', desc: 'Il materiale è in viaggio verso le nostre strutture (logistiche) per la preparazione.' },
        { title: 'Preparazione della spedizione', desc: 'Abbiamo ricevuto il materiale, stiamo verificando i riferimenti e preparando l\'ordine per la spedizione.' },
        { title: 'Consegnato al corriere', desc: 'Il tuo ordine ha lasciato le nostre strutture ed è stato consegnato al corriere per la spedizione.' },
        { title: 'In transito', desc: 'L\'ordine è in viaggio verso il tuo indirizzo. Puoi seguire il suo percorso con il numero di tracciamento fornito.' },
        { title: 'Consegnato', desc: 'Il tuo ordine è stato consegnato con successo! Se hai problemi, non esitare a contattarci.' }
      ],
      calmMessages: {
        created: [
          'Stiamo preparando il tuo ordine. Nessuna notizia = buon segno',
          'Ordine convalidato e in coda di preparazione. Tutto a posto.',
          'Seguiamo il programma previsto. Ti informeremo non appena ci saranno progressi.'
        ],
        created_stale: [
          'Gli ordini complessi richiedono più tempo. Tutto sotto controllo.',
          'Stiamo gestendo la richiesta. Pazienza e fiducia.',
          'Il sistema si aggiorna regolarmente. Ti informiamo di qualsiasi novità.'
        ],
        to_courier: [
          'Quasi pronto per partire. Il corriere arriverà presto.',
          'Coordinamento del ritiro con il corriere. Nelle prossime ore.',
          'Materiale pronto. Basta solo che il corriere arrivi alle nostre strutture.'
        ],
        shipped: [
          'Il tuo ordine è in viaggio. Controlla lo stato sul sito del corriere.',
          'In viaggio verso il tuo indirizzo. I tempi di consegna ora dipendono dal corriere.',
          'Segui il tracciamento. Se passano giorni senza cambiamenti, contattaci.'
        ],
        delivered: [
          'Il tuo ordine è arrivato! Tutto a posto? Siamo qui se hai bisogno di aiuto.',
          'Ordine consegnato. Se hai firmato tu o qualcuno al tuo indirizzo, tutto va bene.',
          'Grazie mille per il tuo acquisto. Per qualsiasi domanda, contattaci.'
        ]
      },
      shippingStatus: {
        outForDelivery: 'In consegna',
        deliveryAttempt: 'Tentativo di consegna',
        pickedUp: 'Ritirato',
        delayed: 'Ritardato',
        redirected: 'Reindirizzato',
        pickupOffice: 'Disponibile in ufficio',
        undeliverable: 'Non consegnabile',
        damaged: 'Danneggiato',
        lost: 'Perso',
        returned: 'Restituito',
        rejected: 'Rifiutato',
        addressError: 'Errore di indirizzo',
        returnProblem: 'Problema di reso',
        partiallyShipped: 'Parzialmente spedito',
        partiallyDelivered: 'Parzialmente consegnato',
        outForPickup: 'Pronto per il ritiro',
        toCourier: 'Consegna al corriere',
        created: 'Creato',
        information: 'Informazione',
        pending: 'In attesa',
        na: 'N/D',
        shipped: 'Spedito',
        delivered: 'Consegnato'
      },
      order: {
        deliveryInfoLink: 'Ma quando verrà consegnato il mio ordine?',
        materialInfoLink: 'Se avete già il materiale, perché non è stato ancora consegnato al corriere?',
        carrierInfoLink: 'Perché il sito del corriere mostra "non ritirato"?',
        notReceivedButton: 'Non l\'ho ricevuto',
        carrierMoreInfo: 'Maggiori informazioni sul sito del corriere:',
        businessDaysNote: '* Giorni lavorativi',
        returnPackageButton: 'Restituisci il pacco',
        cancelOrderButton: 'Annulla ordine'
      },
      whatsapp: {
        shipmentWithTracking: 'della spedizione {tracking}',
        shipmentNoTracking: 'della spedizione (senza numero di tracciamento)',
        giftCardRequest: 'Vorrei richiedere la carta da 3€'
      },
      ui: {
        progressBarLabel: 'Progresso stimato dell\'ordine',
        loading: 'Ricerca…',
        errorMessage: 'Si è verificato un errore durante il controllo del tracciamento.',
        speakToAgent: 'Parla con un agente',
        retry: 'Riprova',
        state: 'Stato:',
        businessDaysElapsed: 'Giorni trascorsi (giorni lavorativi)',
        tracking: 'Tracciamento',
        carrier: 'Corriere',
        status: 'Stato',
        lastUpdate: 'Ultimo aggiornamento',
        recipient: 'Destinatario',
        packages: 'Pacchi',
        copyTrackingLabel: 'Copia numero di tracciamento',
        compensationButton: 'Ti regaliamo 3 € per l\'attesa',
        helpbarMessage: 'Se hai domande, puoi parlare con un agente <a href="/pages/consulta-sobre-pedidos?Message=Ho%20bisogno%20di%20maggiori%20informazioni%20sulla%20spedizione" target="_blank" rel="noopener">cliccando qui</a>.',
        bizDaysValue: '≈ {count} giorni lavorativi',
        bizDaysDisclaimer: 'Il numero di giorni lavorativi indicato è approssimativo e potrebbe essere inferiore: non sono inclusi i giorni festivi locali, regionali o nazionali.'
      },
      legend: {
        completed: 'Completato',
        inProgress: 'In corso',
        pending: 'In attesa'
      },
      modals: {
        delivery: {
          title: 'Tempi di consegna stimati',
          intro: 'Il tempo di consegna stimato per gli ordini è:',
          spainStock: '<strong>Se il prodotto è disponibile in Spagna:</strong> tra <strong>2 e 7 giorni lavorativi</strong>.',
          germanyStock: '<strong>Se il prodotto è disponibile in Germania o altri magazzini:</strong> tra <strong>7 e 14 giorni lavorativi</strong>.',
          bmwNote: '(Per i prodotti BMW originali, la probabilità di disponibilità in Germania o altri magazzini è del 90%.)',
          destinations: 'I tempi indicati si applicano a Spagna, Portogallo, Andorra e Francia. Per altre destinazioni, i tempi di consegna possono essere più lunghi.',
          specialConditions: '<strong>Condizioni speciali:</strong>',
          androidScreens: '• Gli schermi o moduli Android richiedono tra <strong>7 e 14 giorni aggiuntivi</strong> a causa della loro configurazione personalizzata.',
          bulkyProducts: '• I prodotti ingombranti o con logistica speciale potrebbero richiedere un po\' più di tempo.',
          disclaimer: '<em>Questi tempi sono indicativi. Potrebbero esserci piccoli ritardi dovuti ad alta domanda o processi doganali. In ogni caso, il tempo massimo di consegna è di <strong>30 giorni di calendario per la Spagna</strong> e <strong>90 giorni di calendario per spedizioni internazionali</strong>.</em>',
          reassurance: 'Tranquillità prima di tutto: il tuo ordine è in corso e ti informeremo non appena passerà al prossimo step'
        },
        cancel: {
          title: 'Posso annullare il mio ordine?',
          beforeReceiving: '<strong>Prima di ricevere il pacco:</strong><br> I nostri processi sono automatici e veloci. Una volta avviata la spedizione, non è possibile annullarla, ma potrai restituirla facilmente quando la ricevi.',
          within14Days: '<strong>Dopo averlo ricevuto (fino a 14 giorni):</strong><br> Puoi esercitare il tuo diritto di recesso. L\'importo sarà rimborsato con lo stesso metodo di pagamento, detraendo le spese di spedizione (andata e ritorno).',
          between15And30Days: '<strong>Tra 15 e 30 giorni dalla consegna:</strong><br> Ti offriamo un\'opzione extra: <strong>carta regalo del 50% dell\'importo</strong>, purché il prodotto sia inutilizzato e in perfette condizioni.',
          shippingCostNote: '<em>Anche se la spedizione era "gratuita", questi costi esistono e vengono detratti allo stesso modo secondo la tariffa.</em>',
          helpNote: '<em>Siamo qui per aiutarti: se hai dubbi, contattaci e ti guideremo nel tuo caso specifico.</em>'
        },
        notReceived: {
          title: 'Non l\'hai ancora ricevuto?',
          intro: 'Prima di preoccuparti, controlla questi punti',
          checkPoints: '• Cassetta delle lettere, portineria o reception dell\'edificio.<br>• Balcone, giardino o patio (a volte lasciato discretamente).<br>• Familiari, colleghi o vicini (consegna alternativa abituale).',
          contactMessage: 'Se dopo averlo controllato non appare, <strong>contattaci tramite WhatsApp</strong> e lo verificheremo <strong>all\'istante</strong>:',
          whatsappLink: '<a href="https://api.whatsapp.com/send?phone=34616083226" target="_blank" rel="noopener">Apri chat WhatsApp</a>',
          reassurance: '<em>Siamo qui affinché tu non debba preoccuparti di nulla.</em>'
        },
        compensation: {
          title: 'Compensazione per ritardo stimato',
          delayDetected: 'Abbiamo rilevato un piccolo ritardo logistico, ma il tuo ordine <strong>continua senza incidenti</strong>.',
          offer: 'Come ringraziamento per la tua pazienza, ti offriamo una <strong>carta regalo da 3 €</strong> per il tuo prossimo acquisto.',
          terms: 'Una per ordine. Non cumulabile. Valida 90 giorni.',
          requestButton: 'Richiedi carta da 3 €',
          notNow: 'Non ora'
        },
        carrierInfo: {
          title: 'Perché il corriere mostra "non ritirato"?',
          dontWorry: 'Non preoccuparti, <strong>abbiamo già consegnato il pacco al corriere</strong>.',
          inTransit: 'Ora è in transito verso il loro <strong>centro logistico</strong>, dove sarà <strong>etichettato, scansionato e registrato</strong>.',
          scanningNote: 'Fino a quando questa prima scansione non sarà completata, il sito del corriere potrebbe mostrare "non ritirato" o sembrare senza movimento.',
          autoUpdate: 'Non appena verrà elaborato, <strong>il tracciamento si aggiornerà automaticamente</strong>.',
          reassurance: '<em>Il tuo ordine è in buone mani e procede correttamente.</em>'
        },
        material: {
          title: 'Perché non è stato ancora consegnato al corriere?',
          intro: 'È vero che <strong>abbiamo già ricevuto il tuo materiale</strong>, ma prima di inviarlo passa attraverso un processo molto accurato',
          step1: '<strong>1. Scarico e classificazione:</strong> i camion vengono scaricati e i colli vengono ordinati per ordine.',
          step2: '<strong>2. Verifica dei riferimenti:</strong> controlliamo tutti i pezzi uno per uno per assicurarci che corrispondano e siano perfetti.',
          step3: '<strong>3. Preparazione della spedizione:</strong> imballiamo correttamente e assegniamo l\'ordine al corriere.',
          currentPhase: '<em>Il tuo ordine è in questa fase finale di controllo qualità.</em>',
          soonPickup: '<em>Presto il corriere lo ritirerà e riceverai l\'avviso di spedizione.</em>',
          thanks: '<em>Grazie per la tua pazienza: tutto sta procedendo come previsto.</em>'
        }
      },
      incidents: {
        delay: {
          title: 'Ritardo rilevato',
          message: 'La tua spedizione registra un ritardo temporaneo da parte del corriere.'
        },
        attempt: {
          title: 'Tentativo di consegna fallito',
          message: 'La consegna è stata tentata e non è stato possibile completarla.'
        },
        address: {
          title: 'Problema di indirizzo',
          message: 'C\'è un problema con l\'indirizzo di consegna. Per favore controllalo.'
        },
        redirected: {
          title: 'Reindirizzato',
          message: 'Il pacco è stato reindirizzato a un punto di consegna alternativo.'
        },
        undeliverable: {
          title: 'Non consegnabile',
          message: 'Il corriere non è riuscito a completare la consegna.'
        },
        damaged: {
          title: 'Incidente del corriere',
          message: 'Pacco danneggiato.'
        },
        lost: {
          title: 'Incidente del corriere',
          message: 'Pacco perso.'
        },
        returned: {
          title: 'Restituito',
          message: 'Il pacco è stato restituito.'
        },
        partial: {
          title: 'Consegna parziale',
          message: 'Questo ordine viene consegnato in più colli e potrebbero arrivare in momenti diversi.'
        },
        outForDelivery: {
          title: 'ATTENZIONE! In consegna OGGI',
          message: 'Se non si verifica alcun incidente, la consegna verrà effettuata OGGI. Si prega di avere qualcuno all\'indirizzo per ricevere il pacco. Se non fosse possibile, fornire autorizzazione o consegna alternativa al corriere.'
        }
      },
      schema: {
        defaultText: 'Ordine in elaborazione.',
        pickedUp: 'Pacco ritirato dal corriere. In transito.',
        outForDelivery: 'In consegna oggi. Resta attento alla consegna.',
        deliveryAttempt: 'Tentativo di consegna non completato.',
        delayed: 'Ritardo rilevato dal corriere.',
        redirected: 'Disponibile per il ritiro o reindirizzato al punto di consegna.',
        addressError: 'Problema con l\'indirizzo di consegna.',
        undeliverable: 'Spedizione non consegnabile. Richiede gestione.',
        damaged: 'Incidente: pacco danneggiato.',
        lost: 'Incidente: pacco perso.',
        returned: 'Reso in corso o completato.',
        partiallyDelivered: 'Consegna parziale: più colli potrebbero arrivare in momenti diversi.',
        pending: 'Ordine registrato. In attesa di movimento iniziale.'
      },
      footer: {
        disclaimer: 'Sito web indipendente. Non affiliato o autorizzato da BMW AG, MINI o BMW Motorrad.',
        shopName: 'Ricambi e accessori originali e compatibili per la tua BMW, MINI e Motorrad',
        newsletterHeading: 'Le migliori offerte e novità su <strong>BMW, MINI e Motorrad</strong>, direttamente nella tua casella di posta.'
      },
      countries: {
        germany: 'Germania',
        spain: 'Spagna',
        destination: 'Destinazione'
      },
      product: {
        saleBadge: (window.__themeConfig && window.__themeConfig.promoBadges && window.__themeConfig.promoBadges.it) || '',
        startingAt: 'A partire da'
      },
      reviews: {
        trustpilotText: 'Su Trustpilot',
        safeBrowsingStatus: 'Sito sicuro'
      }
    },
    pt: {
      copy: 'Copiar',
      copied: 'Copiado',
      close: 'Fechar',
      retry: 'Tentar novamente',
      searching: 'Pesquisando…',
      understood: 'Entendido',
      notNow: 'Agora não',
      shippingRateEstimator: {
        title: 'Calcular o custo real do envio',
        hint: 'Depende do país, código postal e produtos do carrinho.',
        country: 'País',
        postcode: 'Código postal',
        province: 'Distrito/estado (se aplicável)',
        button: 'CALCULAR ENVIO',
        loading: 'A calcular com as tarifas atuais…',
        result: 'Opções disponíveis',
        none: 'Não existe uma tarifa disponível para esta morada.',
        error: 'Não foi possível calcular. Confirme o código postal ou tente novamente.'
      },
      faqTitle: 'Perguntas Frequentes',
      productAi: {
        title: 'Tem alguma dúvida sobre este produto?',
        subtitle: 'O nosso assistente inteligente responde imediatamente com informações reais do produto.',
        placeholder: 'Perguntar...',
        button: 'Perguntar',
        errorResponse: 'Não foi possível obter resposta. Tente novamente.',
        errorConnection: 'Erro de conexão. Verifique a sua rede.',
        loading: [
          'Analisando a sua pergunta…',
          'Consultando catálogos BMW…',
          'Acelerando resposta…',
          'Verificando compatibilidade…',
          'Processando informações…'
        ]
      },
      orderSteps: [
        { title: 'Pedido recebido', desc: 'A sua compra foi registrada com sucesso e validámos os detalhes do pedido.' },
        { title: 'Pedido em curso', desc: 'Solicitámos o material necessário aos nossos armazéns, BMW Alemanha, fornecedores ou oficinas associadas.' },
        { title: 'Em trânsito para as nossas instalações', desc: 'O material está a caminho das nossas instalações (de logística) para preparação.' },
        { title: 'A preparar o seu envio', desc: 'Recebemos o material, estamos a verificar as referências e a preparar o pedido para expedição.' },
        { title: 'Entregue ao transportador', desc: 'O seu pedido já saiu das nossas instalações e foi entregue ao transportador para envio.' },
        { title: 'Em trânsito', desc: 'O pedido está a caminho do seu endereço. Pode seguir o percurso com o número de rastreamento fornecido.' },
        { title: 'Entregue', desc: 'O seu pedido foi entregue com sucesso! Se tiver algum problema, não hesite em contactar-nos.' }
      ],
      calmMessages: {
        created: [
          'Estamos a preparar o seu pedido. Sem novidades = bom sinal',
          'Pedido validado e em fila de preparação. Tudo em ordem.',
          'Seguimos o plano previsto. Avisaremos assim que houver progresso.'
        ],
        created_stale: [
          'Pedidos complexos demoram mais tempo. Tudo sob controlo.',
          'Estamos a gerir o pedido. Paciência e confiança.',
          'O sistema atualiza-se regularmente. Avisamos de qualquer novidade.'
        ],
        to_courier: [
          'Quase pronto para sair. O transportador virá em breve.',
          'A coordenar recolha com o transportador. Nas próximas horas.',
          'Material pronto. Só falta o transportador passar pelas nossas instalações.'
        ],
        shipped: [
          'O seu pedido está a caminho. Consulte o estado no site do transportador.',
          'A caminho do seu endereço. O tempo de entrega depende agora do transportador.',
          'Siga o rastreamento. Se passarem dias sem mudanças, contacte-nos.'
        ],
        delivered: [
          'O seu pedido chegou! Está tudo correto? Estamos aqui se precisar de ajuda.',
          'Pedido entregue. Se assinou você ou alguém no seu endereço, está tudo em ordem.',
          'Muito obrigado pela sua compra. Qualquer dúvida, contacte-nos.'
        ]
      },
      shippingStatus: {
        outForDelivery: 'Em entrega',
        deliveryAttempt: 'Tentativa de entrega',
        pickedUp: 'Recolhido',
        delayed: 'Atrasado',
        redirected: 'Redirecionado',
        pickupOffice: 'Disponível no escritório',
        undeliverable: 'Não entregável',
        damaged: 'Danificado',
        lost: 'Perdido',
        returned: 'Devolvido',
        rejected: 'Rejeitado',
        addressError: 'Erro de endereço',
        returnProblem: 'Problema com devolução',
        partiallyShipped: 'Parcialmente enviado',
        partiallyDelivered: 'Parcialmente entregue',
        outForPickup: 'Pronto para recolha',
        toCourier: 'Entrega ao transportador',
        created: 'Criado',
        information: 'Informação',
        pending: 'Pendente',
        na: 'N/D',
        shipped: 'Enviado',
        delivered: 'Entregue'
      },
      order: {
        deliveryInfoLink: 'Mas quando será entregue o meu pedido?',
        materialInfoLink: 'Se já têm o material, porque ainda não foi entregue ao transportador?',
        carrierInfoLink: 'Porque é que o site do transportador diz "não recolhido"?',
        notReceivedButton: 'Não recebi',
        carrierMoreInfo: 'Mais informações no site do transportador:',
        businessDaysNote: '* Dias úteis',
        returnPackageButton: 'Devolver a encomenda',
        cancelOrderButton: 'Cancelar pedido'
      },
      whatsapp: {
        shipmentWithTracking: 'do envio {tracking}',
        shipmentNoTracking: 'do envio (sem número de rastreamento)',
        giftCardRequest: 'Gostaria de solicitar o cartão de 3€'
      },
      ui: {
        progressBarLabel: 'Progresso estimado do pedido',
        loading: 'A pesquisar…',
        errorMessage: 'Ocorreu um erro ao consultar o rastreamento.',
        speakToAgent: 'Falar com um agente',
        retry: 'Tentar novamente',
        state: 'Estado:',
        businessDaysElapsed: 'Dias decorridos (dias úteis)',
        tracking: 'Rastreamento',
        carrier: 'Transportador',
        status: 'Estado',
        lastUpdate: 'Última atualização',
        recipient: 'Destinatário',
        packages: 'Encomendas',
        copyTrackingLabel: 'Copiar número de rastreamento',
        compensationButton: 'Oferecemos 3 € pela espera',
        helpbarMessage: 'Se tiver alguma questão, pode falar com um agente <a href="/pages/consulta-sobre-pedidos?Message=Preciso%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20envio" target="_blank" rel="noopener">clicando aqui</a>.',
        bizDaysValue: '≈ {count} dias úteis',
        bizDaysDisclaimer: 'O número de dias úteis indicado é aproximado e pode ser inferior: não estão incluídos feriados locais, regionais ou nacionais.'
      },
      legend: {
        completed: 'Concluído',
        inProgress: 'Em curso',
        pending: 'Pendente'
      },
      modals: {
        delivery: {
          title: 'Prazos de entrega estimados',
          intro: 'O prazo de entrega estimado para os pedidos é:',
          spainStock: '<strong>Se o produto está em stock em Espanha:</strong> entre <strong>2 e 7 dias úteis</strong>.',
          germanyStock: '<strong>Se o produto está em stock na Alemanha ou outros armazéns:</strong> entre <strong>7 e 14 dias úteis</strong>.',
          bmwNote: '(Nos produtos originais BMW, a probabilidade de disponibilidade na Alemanha ou outros armazéns é de 90%.)',
          destinations: 'Os prazos indicados aplicam-se a Espanha, Portugal, Andorra e França. Para outros destinos, os prazos de entrega podem ser mais longos.',
          specialConditions: '<strong>Condições especiais:</strong>',
          androidScreens: '• Os ecrãs ou módulos Android requerem entre <strong>7 e 14 dias adicionais</strong> pela sua configuração personalizada.',
          bulkyProducts: '• Os produtos volumosos ou de logística especial podem demorar um pouco mais.',
          disclaimer: '<em>Estes prazos são orientativos. Pode haver pequenos atrasos devido à alta procura ou processos aduaneiros. Em qualquer caso, o prazo máximo de entrega é de <strong>30 dias corridos para Espanha</strong> e <strong>90 dias corridos para envios internacionais</strong>.</em>',
          reassurance: 'Tranquilidade acima de tudo: o seu pedido está em curso e avisaremos assim que passe para o próximo passo'
        },
        cancel: {
          title: 'Posso cancelar o meu pedido?',
          beforeReceiving: '<strong>Antes de receber a encomenda:</strong><br> Os nossos processos são automáticos e rápidos. Uma vez iniciado o envio, não é possível cancelá-lo, mas poderá devolvê-lo facilmente ao recebê-lo.',
          within14Days: '<strong>Depois de recebê-lo (até 14 dias):</strong><br> Pode exercer o seu direito de desistência. O montante será reembolsado no mesmo método de pagamento, deduzindo os custos de envio (ida e volta).',
          between15And30Days: '<strong>Entre 15 e 30 dias desde a entrega:</strong><br> Oferecemos uma opção extra: <strong>cartão presente de 50% do valor</strong>, desde que o produto esteja sem usar e em perfeito estado.',
          shippingCostNote: '<em>Ainda que o envio fosse "gratuito", esses custos existem e são deduzidos igualmente segundo a tarifa.</em>',
          helpNote: '<em>Estamos para ajudar: se tiver dúvidas, contacte-nos e orientaremos no seu caso concreto.</em>'
        },
        notReceived: {
          title: 'Ainda não recebeu?',
          intro: 'Antes de se preocupar, verifique estes pontos',
          checkPoints: '• Caixa de correio, portaria ou receção do edifício.<br>• Varanda, jardim ou pátio (às vezes deixado discretamente).<br>• Familiares, colegas ou vizinhos (entrega alternativa habitual).',
          contactMessage: 'Se após verificar não aparecer, <strong>contacte-nos pelo WhatsApp</strong> e verificaremos <strong>imediatamente</strong>:',
          whatsappLink: '<a href="https://api.whatsapp.com/send?phone=34616083226" target="_blank" rel="noopener">Abrir chat WhatsApp</a>',
          reassurance: '<em>Estamos aqui para que não tenha de se preocupar com nada.</em>'
        },
        compensation: {
          title: 'Compensação por atraso estimado',
          delayDetected: 'Detetámos um pequeno atraso logístico, mas o seu pedido <strong>continua em curso e sem incidentes</strong>.',
          offer: 'Como agradecimento pela sua paciência, oferecemos um <strong>cartão presente de 3 €</strong> para a sua próxima compra.',
          terms: 'Um por pedido. Não acumulável. Válido 90 dias.',
          requestButton: 'Solicitar cartão de 3 €',
          notNow: 'Agora não'
        },
        carrierInfo: {
          title: 'Porque o transportador mostra "não recolhido"?',
          dontWorry: 'Não se preocupe, <strong>já entregámos a encomenda ao transportador</strong>.',
          inTransit: 'Agora encontra-se em trânsito para o seu <strong>centro logístico</strong>, onde será <strong>etiquetado, digitalizado e registado</strong>.',
          scanningNote: 'Até que se complete essa primeira digitalização, o site do transportador pode mostrar "não recolhido" ou parecer sem movimento.',
          autoUpdate: 'Assim que for processado, <strong>o rastreamento atualizará automaticamente</strong>.',
          reassurance: '<em>O seu pedido está em boas mãos e avança corretamente.</em>'
        },
        material: {
          title: 'Porque ainda não foi entregue ao transportador?',
          intro: 'É verdade que <strong>já recebemos o seu material</strong>, mas antes de enviá-lo passa por um processo muito cuidadoso',
          step1: '<strong>1. Descarga e classificação:</strong> descarregam-se os camiões e ordenam-se as encomendas por pedido.',
          step2: '<strong>2. Revisão de referências:</strong> verificamos uma a uma todas as peças para assegurar que coincidem e estão perfeitas.',
          step3: '<strong>3. Preparação do envio:</strong> embalamos corretamente e atribuímos o pedido ao transportador.',
          currentPhase: '<em>O seu pedido está nesta fase final de controlo de qualidade.</em>',
          soonPickup: '<em>Em breve o transportador recolherá e receberá o aviso de envio.</em>',
          thanks: '<em>Obrigado pela sua paciência: tudo vai segundo o previsto.</em>'
        }
      },
      incidents: {
        delay: {
          title: 'Atraso detetado',
          message: 'O seu envio regista um atraso pontual por parte do transportador.'
        },
        attempt: {
          title: 'Tentativa de entrega falhada',
          message: 'Tentou-se a entrega e não foi possível completá-la.'
        },
        address: {
          title: 'Problema com o endereço',
          message: 'Há um problema com o endereço de entrega. Por favor, reveja-o.'
        },
        redirected: {
          title: 'Redirecionado',
          message: 'A encomenda foi redirecionada para um ponto de entrega alternativo.'
        },
        undeliverable: {
          title: 'Não entregável',
          message: 'O transportador não conseguiu completar a entrega.'
        },
        damaged: {
          title: 'Incidente do transportador',
          message: 'Encomenda danificada.'
        },
        lost: {
          title: 'Incidente do transportador',
          message: 'Encomenda extraviada.'
        },
        returned: {
          title: 'Devolvido',
          message: 'A encomenda foi devolvida.'
        },
        partial: {
          title: 'Entrega parcial',
          message: 'Este pedido é servido em várias encomendas e poderiam chegar em momentos distintos.'
        },
        outForDelivery: {
          title: 'ATENÇÃO! Em entrega HOJE',
          message: 'Se não surgir nenhum incidente, a entrega realizar-se-á HOJE. Pedimos que haja alguém no endereço para receber a encomenda. Se não for possível, facilite autorização ou alternativa de entrega ao transportador.'
        }
      },
      schema: {
        defaultText: 'Pedido em processo.',
        pickedUp: 'Encomenda recolhida pelo transportador. Em trânsito.',
        outForDelivery: 'Em entrega hoje. Mantenha-se atento à entrega.',
        deliveryAttempt: 'Tentativa de entrega não completada.',
        delayed: 'Atraso detetado por parte do transportador.',
        redirected: 'Disponível para recolha ou redirecionado para ponto de entrega.',
        addressError: 'Problema com o endereço de entrega.',
        undeliverable: 'Envio não entregável. Requer gestão.',
        damaged: 'Incidente: encomenda danificada.',
        lost: 'Incidente: encomenda extraviada.',
        returned: 'Devolução em curso ou completada.',
        partiallyDelivered: 'Entrega parcial: várias encomendas poderiam chegar em momentos distintos.',
        pending: 'Pedido registado. Pendente de movimento inicial.'
      },
      footer: {
        disclaimer: 'Site independente. Não afiliado ou autorizado pela BMW AG, MINI ou BMW Motorrad.',
        shopName: 'Peças e acessórios originais e compatíveis para o seu BMW, MINI e Motorrad',
        newsletterHeading: 'As melhores ofertas e notícias sobre <strong>BMW, MINI e Motorrad</strong>, direto na sua caixa de correio.'
      },
      countries: {
        germany: 'Alemanha',
        spain: 'Espanha',
        destination: 'Destino'
      },
      product: {
        saleBadge: (window.__themeConfig && window.__themeConfig.promoBadges && window.__themeConfig.promoBadges.pt) || '',
        startingAt: 'A partir de'
      },
      reviews: {
        trustpilotText: 'No Trustpilot',
        safeBrowsingStatus: 'Site seguro'
      }
    }
  };

  if (contactMode === 'wazion') {
    const chatOverrides = {
      es: {
        contactMessage: 'Si tras comprobarlo no aparece, <strong>contáctanos por el chat</strong> y lo revisaremos <strong>al instante</strong>:',
        linkText: 'Abrir chat',
        message: 'Necesito ayuda con un envío que no aparece tras la comprobación.'
      },
      en: {
        contactMessage: 'If after checking it still does not appear, <strong>contact us via chat</strong> and we will check it <strong>right away</strong>:',
        linkText: 'Open chat',
        message: 'I need help with a shipment that does not appear after checking.'
      },
      de: {
        contactMessage: 'Wenn es nach der Überprüfung nicht auftaucht, <strong>kontaktieren Sie uns per Chat</strong> und wir prüfen es <strong>sofort</strong>:',
        linkText: 'Chat öffnen',
        message: 'Ich benötige Hilfe mit einer Sendung, die nach der Prüfung nicht erscheint.'
      },
      fr: {
        contactMessage: 'Si après vérification il n’apparaît pas, <strong>contactez-nous via le chat</strong> et nous vérifierons <strong>immédiatement</strong> :',
        linkText: 'Ouvrir le chat',
        message: 'J’ai besoin d’aide pour un envoi qui n’apparaît pas après vérification.'
      },
      it: {
        contactMessage: 'Se dopo averlo controllato non appare, <strong>contattaci tramite chat</strong> e lo verificheremo <strong>subito</strong>:',
        linkText: 'Apri chat',
        message: 'Ho bisogno di aiuto con una spedizione che non appare dopo il controllo.'
      },
      pt: {
        contactMessage: 'Se após verificar não aparecer, <strong>contacte-nos pelo chat</strong> e verificaremos <strong>imediatamente</strong>:',
        linkText: 'Abrir chat',
        message: 'Preciso de ajuda com um envio que não aparece após a verificação.'
      }
    };

    Object.keys(chatOverrides).forEach(function(locale) {
      const target = translations[locale] && translations[locale].modals && translations[locale].modals.notReceived;
      const copy = chatOverrides[locale];
      if (!target || !copy) return;
      target.contactMessage = copy.contactMessage;
      target.whatsappLink = `<a href="${buildChatPageUrl(copy.message)}" target="_blank" rel="noopener">${copy.linkText}</a>`;
    });
  }

  const trackingHelpMessages = {
    es: 'Necesito más información sobre el envío',
    en: 'I need more information about the shipment',
    de: 'Ich benötige weitere Informationen zur Sendung',
    fr: 'J’ai besoin de plus d’informations sur l’envoi',
    it: 'Ho bisogno di maggiori informazioni sulla spedizione',
    pt: 'Preciso de mais informações sobre o envio'
  };

  Object.keys(trackingHelpMessages).forEach(function(locale) {
    const ui = translations[locale] && translations[locale].ui;
    if (!ui || !ui.helpbarMessage) return;
    ui.helpbarMessage = ui.helpbarMessage.replace(
      /href="[^"]*"/,
      `href="${buildContactUrl(trackingHelpMessages[locale])}"`
    );
  });

  // Seleccionar las traducciones según el locale actual
  // Si no encuentra el locale exacto (ej: pt-PT), intenta con el código base (ej: pt)
  let selectedTranslations = translations[currentLocale];
  if (!selectedTranslations && currentLocale.includes('-')) {
    const baseLocale = currentLocale.split('-')[0];
    selectedTranslations = translations[baseLocale];
  }
  selectedTranslations = selectedTranslations || translations['es'];

  window.themeTranslations = {
    locale: currentLocale,
    strings: selectedTranslations
  };

  // Helper function para acceder a traducciones fácilmente
  window.t = function(key) {
    const keys = key.split('.');
    let value = window.themeTranslations.strings;
    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) {
        console.warn(`Translation missing: ${key}`);
        return key;
      }
    }
    return value;
  };

  // Translate product card elements on page load
  function translateProductCards() {
    // Translate all sale badges
    document.querySelectorAll('.js-sale-badge').forEach(function(el) {
      const label = window.t('product.saleBadge');
      if (el.textContent !== label) el.textContent = label;
    });

    // Translate all "starting at" texts
    document.querySelectorAll('.js-starting-at').forEach(function(el) {
      const label = window.t('product.startingAt');
      if (el.textContent !== label) el.textContent = label;
    });
  }

  // Run translations when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateProductCards);
  } else {
    translateProductCards();
  }

  // Also observe for dynamically added product cards (e.g., infinite scroll, AJAX)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      // Text updates also produce mutations; idempotent writes let the observer settle.
      if (mutations.some(function(mutation) { return mutation.addedNodes.length; })) {
        translateProductCards();
      }
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
})();
